import React from 'react';
import PropTypes from 'prop-types';
import { IS_TAB } from '../../../../utils/common';
import SelectableButton from '../../../../components/common/SelectableButton';
import Carousel from '../../../../components/common/Carousel';
import useCarouselItemConfig from '../../../../hooks/useCarouselItemConfig';
import GridLayout from '../../../../components/common/GridLayout';
import { removePartConfig } from '../../../../containers/customizer.duck';

const WinterProtection = ({
  options,
  updatePartsConfig,
  selectedPart,
  removePartConfig,
  selectedCategory
}) => {
  const { ref: cardRef, width: itemWidth } = useCarouselItemConfig();
  const renderItems = options.map(
    ({ configData: { label }, partId }, index) => (
      <div className="jacket-winter-protection_item" ref={cardRef}>
        <SelectableButton
          name={partId}
          label={label}
          id={partId}
          value={label}
          isSelected={
            (selectedPart && selectedPart === partId) ||
            (!selectedPart && !partId)
          }
          onChange={() => {
            if (!options[index].partId) {
              removePartConfig('winterProtection');
            } else updatePartsConfig(options[index]);
          }}
        />
      </div>
    )
  );

  return (
    <div className="jacket-winter-protection">
      {IS_TAB ? (
        <Carousel itemWidth={itemWidth} noOfItems={options && options.length}>
          {renderItems}
        </Carousel>
      ) : (
        <GridLayout columns={3} columnsWidth={120} alignCenter>
          {renderItems}
        </GridLayout>
      )}
    </div>
  );
};

WinterProtection.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  partsConfig: PropTypes.object,
  selectedPart: PropTypes.string
};

export default WinterProtection;
